import RegistrationAnalysisSection = Infospeed.Services.ClassWeb.API.Contracts.COT.RegistrationAnalysisSection;
import RegistrationAnalysis = Infospeed.Services.ClassWeb.API.Contracts.COT.RegistrationAnalysis;
import WebBookingControlType = Infospeed.Services.ClassWeb.API.Contracts.COT.WebBookingControlType;
import AnalysisUDFItem = Infospeed.Services.ClassWeb.API.Contracts.COT.AnalysisUDFItem;

import { Component, OnInit, Input, OnChanges, SimpleChange, DoCheck, ChangeDetectionStrategy, ChangeDetectorRef, ViewChild, Output, EventEmitter, ViewChildren, QueryList } from '@angular/core';
import { NgForm, ControlContainer } from '@angular/forms';
import { CotAnalysisFormComponent, ICotAnalysisChangeEvent, ICotAnalysis } from '../cot-analysis-form/cot-analysis-form.component';
import { CustomDialogComponent } from '../custom-dialog/custom-dialog.component';
import { ConvertToIAnalysisUDFItems } from '../cot-analysis-form/cot-analysis-form.component';

@Component({
  selector: 'cot-udfs-regular-form',
  templateUrl: './cot-udfs-regular-form.component.html',
  styleUrls: ['../widgets-custom-theme.scss', './cot-udfs-regular-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }]
})
export class CotUdfsRegularFormComponent implements OnInit, OnChanges {
  // inputs
  @Input('analysisSections') analysisSections: RegistrationAnalysisSection[] = [];
  @Input('form') form: NgForm;
  @Input('validateError') validateError: boolean = true;
  @Input('numbering') numbering: boolean = true;
  @Input('disabled') disabled: boolean = false;
  @Input('startingNumber') startingNumber: number = 1;
  // view-childs
  @ViewChild('validationDialog') validationDialog: CustomDialogComponent;
  @ViewChildren(CotAnalysisFormComponent) cotAnalysisFormComponents: QueryList<CotAnalysisFormComponent>;

  constructor(private changeDetectorRef: ChangeDetectorRef) {
  }

  ngOnInit() {
  }

  ngOnChanges(changes: { [propKey: string]: SimpleChange }) { // model reference changes
    for (let propName in changes) {
      let changedProp = changes[propName];
      ////let to = JSON.stringify(changedProp.currentValue);
      if (propName === 'analysisSections') {
        // do something here
        //this.disableEnableNavigationButtons();
      }
    }
  }

  ngDoCheck() { // property of the model changes
  }

  ngAfterViewInit() {
    // disable/enable navigation buttons
    //setTimeout(this.disableEnableNavigationButtons(), 250);
  }

  isSectionInvalid(sectionId: number): boolean {
    if (!sectionId || sectionId == 0) return;
    let isInvalid: boolean = false;
    let selectedSection: RegistrationAnalysisSection = this.analysisSections.filter(x => x.AnalysisSectionId === sectionId)[0];
    for (let i: number = 0; i < selectedSection.Analyses.length; i++) {
      if (this.form.controls[selectedSection.Analyses[i].AnalysisNameId])
        if (this.form.controls[selectedSection.Analyses[i].AnalysisNameId].invalid) {
          isInvalid = true;
          break;
        }
    }
    return isInvalid;
  }

  hasSectionError(sectionId: number): boolean {
    if (!sectionId || sectionId == 0) return;
    let hasError: boolean = false;
    let selectedSection: RegistrationAnalysisSection = this.analysisSections.filter(x => x.AnalysisSectionId === sectionId)[0];
    for (let i: number = 0; i < selectedSection.Analyses.length; i++) {
      if (this.form.controls[selectedSection.Analyses[i].AnalysisNameId])
        if (this.form.controls[selectedSection.Analyses[i].AnalysisNameId].touched && this.form.controls[selectedSection.Analyses[i].AnalysisNameId].errors) {
          hasError = true;
          break;
        }
    }
    return hasError;
  }

  public hasFormError(): boolean {
    let hasError: boolean = false;
    for (let i: number = 0; i < this.analysisSections.length; i++) {
      if (hasError) break;
      for (let j: number = 0; j < this.analysisSections[i].Analyses.length; j++) {
        const control = this.form.controls[this.analysisSections[i].Analyses[j].AnalysisNameId];
        if (control && control.touched && control.errors) {
          hasError = true;
          break;
        }
      }
    }
    return hasError;
  }

  public getIAnalysisUDFItems(): any[] {
    let iAnalysisUDFItems: any[] = [];
    this.analysisSections.forEach(section => {
      let iItems = ConvertToIAnalysisUDFItems(section.Analyses);
      if (iItems && iItems.length > 0)
        iAnalysisUDFItems.push(...iItems);
    });
    return iAnalysisUDFItems;
  }
  
  public resetToDefault() {
    if (this.cotAnalysisFormComponents)
      this.cotAnalysisFormComponents.forEach(x => {
        x.resetToDefault();
      });
  }

  public disable(disable: boolean = true) {
    if (this.cotAnalysisFormComponents)
      this.cotAnalysisFormComponents.forEach(x => {
        x.disable(disable);
      });
  }

  public validateControls() {
    this.analysisSections.forEach(section => {
      section.Analyses.forEach(x => {
        const control = this.form.control.get(x.AnalysisNameId.toString());
        if (control && control.invalid) {
          control.markAsTouched({ onlySelf: true });
          control.updateValueAndValidity({ onlySelf: true }); // updateValueAndValidity() is required to highlight the invalid control
        }
      });
    });
  }

  onAnalysisChange($event: ICotAnalysisChangeEvent) {
    const cotAnalysis: ICotAnalysis = $event.CotAnalysis;
    // update registration-analysis
    let registrationAnalysisSection: RegistrationAnalysisSection = this.analysisSections.filter(x => x.AnalysisSectionId == cotAnalysis.AnalysisSectionId)[0];
    let registrationAnalysis: RegistrationAnalysis = registrationAnalysisSection.Analyses.filter(x => x.AnalysisNameId == cotAnalysis.AnalysisNameId)[0];
    registrationAnalysis.Content = cotAnalysis.Content;
    registrationAnalysis.Date = cotAnalysis.Date;
    registrationAnalysis.Note = cotAnalysis.Note;
  }
}

export interface ICotParentalConsentTabChangeEvent {
  Id: number | string;
}



// WEBPACK FOOTER //
// ./src/app/widgets/cot-udfs-regular-form/cot-udfs-regular-form.component.ts